export const isActiveProduct = (product) => product?.status === 'active';

export const getProductStatusLabel = (status) => {
  switch (status) {
    case 'active':
      return 'Actif';
    case 'brouillon':
      return 'Brouillon';
    case 'inactive':
      return 'Inactif';
    case 'archive':
      return 'Archivé';
    default:
      return status || 'Inconnu';
  }
};

export const getFeaturedToggleState = (product, featuredCount, maxFeatured) => {
  const isFeatured = Boolean(product?.is_featured || product?.featured_order);

  if (!isActiveProduct(product)) {
    return {
      visible: true,
      disabled: true,
      title: `Statut « ${getProductStatusLabel(product?.status)} » — seuls les produits actifs peuvent être mis en avant`,
    };
  }

  if (!isFeatured && featuredCount >= maxFeatured) {
    return {
      visible: true,
      disabled: true,
      title: `Maximum ${maxFeatured} produits mis en avant — retirez-en un pour en ajouter un autre`,
    };
  }

  return {
    visible: true,
    disabled: false,
    title: isFeatured ? 'Retirer de la mise en avant' : 'Mettre en avant',
  };
};

export default isActiveProduct;
